export default __webpack_public_path__ + "static/media/mob_all.347c1676.webp";